import { CampusWard } from './campus-ward.model';
import { CampusStake } from './campus-stake.model';
import {LocalWard } from './local-ward.model';

export class CampusUnits {
    campusWards: CampusWard[];
    campusStakes: CampusStake[];
    localWards: LocalWard[];
}